import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import * as Constants from '../Shared/Constants.js'
import * as LayoutComponents from '../Shared/LayoutComponents.js'
import '../Shared/Style.css';
import { useDropzone } from 'react-dropzone';
import MultiSelectField from "../Shared/MultiSelectField.js"
import "./App.css";


const ItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [visibleDetailsTab, setVisibleDetailsTab] = useState("information");
    const [autoCallOverviewFunction, setAutoCallOverviewFunction] = useState(false);
    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(AppContext.isPaneOpen);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [componentKey, setComponentKey] = useState(0);
    const [showItemContextMenu, setShowItemContextMenu] = useState(false);
    const [selectedPDFTab, setSelectedPDFTab] = useState("main");
    const [requestingTranslation, setRequestingTranslation] = useState(false);
    const [requestedTranslation, setRequestedTranslation] = useState(false);
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [showDeleteFileConfirmation, setShowDeleteFileConfirmation] = useState(false);
    const [isDeletingFile, setIsDeletingFile] = useState(false);
    const [currentLegalManufacturer, setCurrentLegalManufacturer] = useState("");
    const [selectedPDFVersion, setSelectedPDFVersion] = useState(null);
    const [isVersionDropdownOpen, setIsVersionDropdownOpen] = React.useState(false);
    const [countries, setCountries] = useState([]);

    const [countryRepresentatives, setCountryRepresentatives] = useState([]);
    const [countryDistributors, setCountryDistributors] = useState([]);
    const [importers, setImporters] = useState([]);
    const [certificatesList, setCertificatesList] = useState([]);

    const [isEditMode, setIsEditMode] = useState(false);
    const [version, setVersion] = useState(0);

    const [isEditingField, setIsEditingField] = useState({
        SKUProductCode: false,
        ProductName: false,
        FamilyName: false,
    });

    const [errorCurrentItem, setErrorCurrentItem] = useState(null);
    const [hasUDIUnsavedChanges, setHasUDIUnsavedChanges] = useState(false);
    const [hasProductUnsavedChanges, setHasProductUnsavedChanges] = useState(false);
    
    const [isShowingUDIUnsavedChangesWarning, setIsShowingUDIUnsavedChangesWarning] = useState(false);
    const [isShowingProductUnsavedChangesWarning, setIsShowingProductUnsavedChangesWarning] = useState(false);

    AppContext.hasUDIUnsavedChanges = hasUDIUnsavedChanges;
    AppContext.setHasUDIUnsavedChanges = setHasUDIUnsavedChanges;
    AppContext.isShowingUDIUnsavedChangesWarning = isShowingUDIUnsavedChangesWarning;
    AppContext.setIsShowingUDIUnsavedChangesWarning = setIsShowingUDIUnsavedChangesWarning;

    AppContext.hasProductUnsavedChanges = hasProductUnsavedChanges;
    AppContext.setHasProductUnsavedChanges = setHasProductUnsavedChanges;
    AppContext.isShowingProductUnsavedChangesWarning = isShowingProductUnsavedChangesWarning;
    AppContext.setIsShowingProductUnsavedChangesWarning = setIsShowingProductUnsavedChangesWarning;



    const contextMenuButton = useRef(null);
    const contextMenu = useRef(null);
    const versionsMenuButton = useRef(null);
    const versionsMenuOptions = useRef(null);
    const currentItemSKUProductCodeRef = useRef(null);
    const currentItemProductNameRef = useRef(null);



    
    const isNullOrEmpty = (val) => {
        return val === "" || val === null;
    }

    const hasValue = (val) => {
        return val !== "" && val !== null;
    }
        
        

    function stringifyIfObject(value) {
        if (typeof value === "object" && value !== null) {
            return JSON.stringify(value);
        }
            return value;
    }



    const validFormField = (title, field) => {

        if (isNullOrEmpty(AppContext.currentItem[field])) {
            setErrorCurrentItem(title + " is a mandatory field");
            return false;
        }

        return true;
    }


    const saveCurrentItem = () => {

        // Validations

        let isValidForm = true;

        setErrorCurrentItem(null);

        
        if (!validFormField("Country", "CountryId"))
            isValidForm = false;
        if (!validFormField("Product", "ProductId"))
            isValidForm = false;
        if (!validFormField("Risk Class", "RiskClass"))
            isValidForm = false;
        if (!validFormField("Status", "Status"))
            isValidForm = false;
        if (!validFormField("Selling", "Selling"))
            isValidForm = false;
        if (!validFormField("Priority", "Priority"))
            isValidForm = false;



        if (!isValidForm) return false;

        setIsSavingItem(true);
        setIsShowingSaveMessage(false);
        AppContext.disableAllItemFormFieldsEdit();

        // Update item remotely and if successful...

        let currentItem = JSON.parse(JSON.stringify(AppContext.currentItem));

        currentItem.Entities = AppContext.linkedObjectsList;

        //AppContext.setCurrentItem(currentItem);


        let updateItemURL = AppContext.dataUrl;

        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(currentItem)
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);


                    // Update current item
                    AppContext.setCurrentItem(result);

                    // Update local original item to use when cancelling edit
                    AppContext.setOriginalItem(result);

                    setIsShowingSaveMessage(true);

                    setIsEditMode(false);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItem(false);
            });
    };









    const loadCountries = () => {

        let countriesUrl = "/umbraco/api/RIMSProducts/Countries";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(countriesUrl, requestOptions)
            .then((response) => {
                checkResponseError(response);
                return response.json();
            })
            .then((result) => {
                if (result) {

                    result.sort((a, b) => a.CountryName.localeCompare(b.CountryName));

                    setCountries(result);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });
    };


    
    


        

    const loadCountryRepresentatives = () => {

        let countryRepresentativeRoleId = 3;
        return loadOperators(countryRepresentativeRoleId, setCountryRepresentatives);
    };

    const loadCountryDistributors = () => {

        let countryDistributorRoleId = 4;
        return loadOperators(countryDistributorRoleId, setCountryDistributors);
    };

    const loadImporters = () => {

        let importerRoleId = 2;
        return loadOperators(importerRoleId, setImporters);
    };






    const loadOperators = (roleId, setFunction) => {

        let countriesUrl = "/umbraco/api/RIMSProducts/Operators?roleId=" + roleId;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        return fetch(countriesUrl, requestOptions)
            .then((response) => {
                checkResponseError(response);
                return response.json();
            })
            .then((result) => {
                if (result) setFunction(result);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });

    }




    const loadCertificates = () => {

        let countriesUrl = "/umbraco/api/RIMSRegistrations/GroupedCertificates/";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(countriesUrl, requestOptions)
            .then((response) => {
                checkResponseError(response);
                return response.json();
            })
            .then((result) => {

                if (result)
                    setCertificatesList(result);

            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });

    }


    const checkResponseError = (response) => {

        if (!response.ok) {
            if (response.status === 401)
                document.dispatchEvent(new Event("api:unauthorized"));

            throw new Error("Network response was not ok");
        }

    }



    // On parent change of the details pane status "restart" the popup
    useEffect(() => {

        if (AppContext.isPaneOpen == true) {
            // Immediately activate popup, but wait a bit to trigger the open animation
            setItemDetailsPaneActive(true);
            setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
        }
        else {
            // Immediately do the hide effect but wait 300 to deactivate the popup
            setItemDetailsPaneOpenEffect(false);
            setTimeout(() => { setItemDetailsPaneActive(false); }, 300);
        }

    }, [AppContext.isPaneOpen]);


    const reinitialize = () => {
        changeTab("information");
        setAutoCallOverviewFunction(false);
        setSelectedPDFTab("main");
        setIsUploadingFile(false);
        setIsDeletingFile(false);
        setIsSavingItem(false);
        AppContext.setIsShowingDeleteConfirmation(false);

        loadCountries();
        loadCountryRepresentatives();
        loadCountryDistributors();
        loadImporters();
        loadCertificates();

        setIsShowingSaveMessage(false);

        setIsEditMode(false);


    }

    useEffect(() => {

        if (itemDetailsPaneActive)
            reinitialize();

    }, [itemDetailsPaneActive]);


    useEffect(() => {

        if(!itemDetailsPaneOpenEffect)
            setShowItemContextMenu(false);

    }, [itemDetailsPaneOpenEffect])




    const openContextualMenu = () => {
        setShowItemContextMenu(!showItemContextMenu);
    };



    useEffect(() => {

        const handleClickOutside = (e) => {

            if (contextMenuButton.current && contextMenuButton.current.contains(e.target) ||
                contextMenu.current && contextMenu.current.contains(e.target) ||
                versionsMenuButton.current && versionsMenuButton.current.contains(e.target) ||
                versionsMenuOptions.current && versionsMenuOptions.current.contains(e.target)
            )
                return;

            setIsVersionDropdownOpen(false);
            setShowItemContextMenu(false);
            AppContext.setIsShowingDeleteConfirmation(false);

        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    







    /*
        When in the view/edit pane, when you click a field this will set edit mode on for that field
    */
    const enableTaskFormFieldEdit = (field, e) => {
        e.stopPropagation();
        let newObj = { ...isEditingField, [field]: true };
        setIsEditingField(newObj);
    };



    /*
        Disable all editable fields in the view/edit form
    */
    const disableAllItemFormFieldsEdit = () => {
        let newObj = { ...isEditingField };
        for (let prop in newObj) {
            newObj[prop] = false;
        }
        setIsEditingField(newObj);
    };

    
    const onDrop = useCallback((acceptedFiles) => {

        const formData = new FormData();
        acceptedFiles.forEach(file => formData.append('files', file));

        let requestOptions = {
            method: 'POST',
            body: formData,
        };


        setIsUploadingFile(true);

        let attachmentUrl = "/Umbraco/Api/Compliance/Upload/?complianceType=" + AppContext.ComplianceType + "&uniqueId=" + AppContext.currentItem.UniqueId;

        fetch(attachmentUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data) {

                    // Update item
                    AppContext.setCurrentItem({ ...AppContext.currentItem, MedboardResourceId: data });

                    // Update list
                    // Update list
                    AppContext.setData(list =>
                        list.map(item =>
                            item.Id == AppContext.currentItem.Id ? { ...item, MedboardResourceId: data } : item
                        )
                    );
                    
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsUploadingFile(false);
            });

    }, [AppContext.currentItem]);



    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': [], // PDF
        },
        multiple: false,
    });




    // Canceling edit changes
    const cancelEdit = () => {

        AppContext.setCurrentItem(AppContext.originalItem);
        setIsEditMode(false);
        setVersion(v => v + 1);

    }





    const toggleEditMode = () => {

        setIsEditMode(!isEditMode);

        setIsShowingSaveMessage(false);
    }



    const changeTab = (tab) => {

        setIsShowingSaveMessage(false);

        setVisibleDetailsTab(tab);


    }


    const closePane = () => {

        AppContext.closePane();

    }




    

    const deepEqual = (a, b) => {
        if (a === b) return true;

        if (
            typeof a !== "object" || a === null ||
            typeof b !== "object" || b === null
        ) {
            return false;
        }

        const keysA = Object.keys(a);
        const keysB = Object.keys(b);

        if (keysA.length !== keysB.length) return false;

        for (let key of keysA) {
            if (!keysB.includes(key)) return false;

            if (!deepEqual(a[key], b[key])) return false;
        }

        return true;
    };



    // Avoid losing unsaved changes

    useEffect(() => {

        if (!deepEqual(AppContext.currentItem, AppContext.originalItem))
            AppContext.setHasProductUnsavedChanges(true);
        else
            AppContext.setHasProductUnsavedChanges(false);

    }, [AppContext.currentItem, AppContext.originalItem]);




    




    const riskClassList = [
        { Id: 0, Name: "I" },
        { Id: 1, Name: "Is" },
        { Id: 2, Name: "Im" },
        { Id: 3, Name: "II" },
        { Id: 4, Name: "IIa" },
        { Id: 5, Name: "IIb" },
        { Id: 6, Name: "III" },
        { Id: 7, Name: "IV" },
        { Id: 8, Name: "A" },
        { Id: 9, Name: "B" },
        { Id: 10, Name: "C" },
        { Id: 11, Name: "D" },
        { Id: 12, Name: "Unclassified" },
        { Id: 13, Name: "Other" },
    ];


    const registrationStatusList = [
        { Id: 7, Name: "Pre-Market Assessment", className: "g-bg-blue" },
        { Id: 0, Name: "New Registration Ongoing", className: "g-bg-blue" },
        { Id: 6, Name: "Registration Not Required", className: "g-bg-gray-light-v1" },
        { Id: 1, Name: "Active", className: "g-bg-green" },
        { Id: 3, Name: "Active - Renewing", className: "g-bg-green" },
        { Id: 4, Name: "Active - Modification", className: "g-bg-green" },
        { Id: 5, Name: "Suspended", className: "g-bg-lightred" },
        { Id: 2, Name: "Expired", className: "g-bg-lightred" },
        { Id: 8, Name: "Discontinued", className: "g-bg-black" },
        { Id: 9, Name: "Not Registered", className: "g-bg-orange" },
    ];


    const yesNoList = [
        { Id: false, Name: "No" },
        { Id: true, Name: "Yes" },
    ];


    const renewalPriorityList = [
        { Id: 0, Name: "None" },
        { Id: 1, Name: "Low" },
        { Id: 2, Name: "Medium" },
        { Id: 3, Name: "High" },
    ];



    const tabs = [
        { title: "Registration Details", tab: "information" },
        { title: "Configurations", tab: "configurations", onlyIfEnabled: !!AppContext.currentItem?.ConfigurableDevice },
    ];


    // DEBUG ONLY
    const displayFieldOnly = true;


    let fullWidthPane = true;

    return (
        <>

            {itemDetailsPaneActive ? 
                
                <div
                    style={{ height: "100vh", overflow: "auto", backgroundColor: "#f7fafc" }}
                    className={`${fullWidthPane ? "slide-pane-full-width" : "slide-pane"} ${itemDetailsPaneOpenEffect ? "open" : ""}`}
                >
                    <div className="content">

                        
                        <p style={{ color: "#555", fontSize: "11px" }}>
                            <span className="breadcrumb-link" style={{ marginRight: "5px" }} onClick={() => closePane()}>Country Registrations</span>
                            {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? null :
                                <>
                                    &gt; <span style={{ marginLeft: "5px" }}>{AppContext.currentItem.ProductSKUCode}</span>
                                </>
                            }
                        </p>
                        
                        


                        

                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}


                        <div className="item-details-content">

                            <div className="item-details-content-tabs">

                                <div className="nav" style={{ display: "flex", flexDirection: "column", gap: "4px" }} >

                                    {tabs.map((tab, index) => {
                                        if (tab.onlyAdmin && AppContext.userRole !== "Admin") {
                                            return null;
                                        }

                                        return (
                                            <a
                                                key={index} // better than index if tab.tab is unique
                                                onClick={() => changeTab(tab.tab)}
                                                className={`nav-item item-details-menu-tab ${visibleDetailsTab === tab.tab ? "active" : ""
                                                    }`}
                                            >
                                                {tab.title}
                                            </a>
                                        );
                                    })}

                                </div>

                            </div>



                            
                            <div className="item-details-content-content">

                                {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                                    <>
                                        <LayoutComponents.PageLoading />
                                    </>
                                ) : (
                                        <>


                                        {/* Header */}

                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                                <h2 style={{ margin: 0, fontSize: "24px", fontWeight: 700, color: "#1a202c", display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <i className="fas fa-box-open" style={{ color: "#2b6cb0" }} />
                                                    Registration Details
                                                </h2>

                                                <span style={{ fontSize: "16px", color: "#4a5568", fontWeight: 600, background: "#edf2f7", padding: "4px 12px", borderRadius: "6px" }}>
                                                        <a target="_blank" href={`/your-medboard/products/?productId=${AppContext.currentItem?.ProductId}`}>{AppContext.currentItem?.ProductSKUCode}&nbsp;&nbsp;•&nbsp;&nbsp;{AppContext.currentItem?.ProductName}</a>
                                                </span>
                                            </div>

                                            <div style={{ display: "flex", gap: "8px" }}>

                                                    {visibleDetailsTab == "information" ? <>

                                                         {AppContext.userRole == "Admin" ? <>

                                                            {isEditMode ?

                                                                <div id="buttom-bar" >

                                                                    {/* FORMS BUTTONS */}

                                                                    <div className="action-button-bar" style={{ marginTop: "0px" }}>

                                                                        <div className="action-button-bar-left"></div>
                                                                        <div className="action-button-bar-center"></div>

                                                                        <div className="action-button-bar-right">

                                                                                                    {!isSavingItem ? (
                                                                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "right", gap: "8px" }}>
                                                                                                            <button
                                                                                                                className="action-button save-button"
                                                                                                                onClick={() => cancelEdit()}
                                                                                                                onMouseOver={(e) => {
                                                                                                                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                                                                                                                    e.currentTarget.style.borderColor = "#c1c4c8";
                                                                                                                }}
                                                                                                                onMouseOut={(e) => {
                                                                                                                    e.currentTarget.style.backgroundColor = "#ffffff";
                                                                                                                    e.currentTarget.style.borderColor = "#dee2e6";
                                                                                                                }}
                                                                                                                style={{
                                                                                                                    display: "inline-flex",
                                                                                                                    alignItems: "center",
                                                                                                                    padding: "6px 14px",
                                                                                                                    cursor: "pointer",
                                                                                                                    transition: "all 0.2s ease-in-out",
                                                                                                                    color: "#5f6368",
                                                                                                                    border: "1px solid #dee2e6",
                                                                                                                    backgroundColor: "#ffffff",
                                                                                                                    whiteSpace: "nowrap",
                                                                                                                    outline: "none"
                                                                                                                }}
                                                                                                            >
                                                                                                                Cancel
                                                                                                            </button>
                                                                                                           <button onClick={saveCurrentItem} className="action-button save-button">Save</button>
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <LoadingSpinnerImage />
                                                                                                        </>
                                                                                                    )}


                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                :
                                                                <>
                                                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                                        <div style={{
                                                                            flex: 1,
                                                                            justifyContent: "right",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            marginRight: "20px",
                                                                        }}>
                                                                            {isShowingSaveMessage ?
                                                                                <span className="save-message-shown">
                                                                                    Save successful!
                                                                                </span>
                                                                                : null}
                                                                        </div>


                                                                        <div>
                                                                            <div className="view-task-field" style={{
                                                                                textAlign: "right",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                marginBottom: "0px",
                                                                            }}>
                                                                                <span onClick={() => toggleEditMode()} value="EDIT" style={{ borderRadius: "20px" }} className="edit-rims-edit-button">
                                                                                    <i className="far fa-edit pointer g-mr-8"></i>Edit Registration
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>



                                                                </>
                                                            }

                                                        </>

                                                            : null}

                                                    </> : null}


                                                    <button ref={contextMenuButton} onClick={openContextualMenu} style={{ border: "1px solid #cbd5e0", background: "white", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", color: "#4a5568" }}>
                                                    <i className="fas fa-ellipsis-v" />
                                                </button>

                                                <button onClick={() => closePane()} style={{ border: "1px solid #cbd5e0", background: "white", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", color: "#4a5568" }}>
                                                    <i className="fas fa-times" />
                                                </button>
                                            </div>
                                        </div>


                                        {/* Main content */}

                                            <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>


                                                {/* INFORMATION DASHBOARD */}

                                                {visibleDetailsTab == "information" ?

                                                    <>


                                                        {/* LEFT */}

                                                        <div style={{ flex: 2, minWidth: "400px", display: "flex", flexDirection: "column", gap: "24px" }}>

                                                            <LayoutComponents.InfoBlock>
                                                                <div style={{ display: "flex", gap: "40px" }}>

                                                                    <div>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Country / Jurisdiction
                                                                        </span>
                                                                        {/* <span style={{ fontSize: isEditMode ? "13px" : "16px", fontWeight: isEditMode ? 500 : 600, color: "#2d3748", display: "flex", alignItems: "center", gap: "6px" }}>
                                                                            {isEditMode ? <>
                                                                                <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"CountryId"} fieldName={"_CountryId"} fieldTitle={"Country"} LOV={countries} LOVIdField={"CountryId"} LOVNameField={"CountryName"} mandatory={true} enableSearch={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />

                                                                            </> : <>
                                                                                {AppContext.currentItem?.CountryName ?
                                                                                    <a target="_blank" href={`/your-medboard/country-registrations/registrations/?filter[CountryId]=${AppContext.currentItem?.CountryId}`}>
                                                                                        <img
                                                                                            className="countryFlag"
                                                                                            src={AppContext.currentItem?.FlagLink}
                                                                                            style={{ height: "20px", marginRight: "5px" }}
                                                                                            alt=""
                                                                                        />
                                                                                        {AppContext.currentItem?.CountryName}
                                                                                    </a>
                                                                                    : "---"}
                                                                            </>}
                                                                    </span>*/ }
                                                                       

                                                                    <span style={{ fontSize: "16px", fontWeight: 600, color: "#2d3748", display: "flex", alignItems: "center", gap: "6px" }}>
                                                                        {AppContext.currentItem?.CountryName ? (
                                                                            <a target="_blank" href={`/your-medboard/country-registrations/registrations/?filter[CountryId]=${AppContext.currentItem?.CountryId}`}>
                                                                                <img
                                                                                    className="countryFlag"
                                                                                    src={AppContext.currentItem?.FlagLink}
                                                                                    style={{ height: "20px", marginRight: "5px" }}
                                                                                    alt=""
                                                                                />
                                                                                {AppContext.currentItem?.CountryName}
                                                                            </a>
                                                                        ) : (
                                                                            "---"
                                                                        )}
                                                                    </span>
                                                                    </div>

                                                                    <div style={{ borderLeft: "1px solid #e2e8f0", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Certificate Reference
                                                                        </span>

                                                                        <span style={{ fontSize: isEditMode ? "13px" : "15px", fontWeight: isEditMode ? 500 : 600, color: "#4a5568", fontFamily: isEditMode ? "" : "monospace" }}>
                                                                            <ItemDetailsField_CertificatesDropdown AppContext={AppContext} fieldId={"CertificateId"} fieldName={"CertificateName"} fieldTitle={"Products Certificate Reference"} LOV={certificatesList} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} link={`/your-medboard/country-registrations/certificates/?certificateId=[PARAM]`} />
                                                                        </span>
                                                                    </div>

                                                                    <div style={{ borderLeft: "1px solid #e2e8f0", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Risk Class
                                                                        </span>

                                                                        <span style={{ fontSize: isEditMode ? "13px" : "15px", fontWeight: isEditMode ? 500 : 600, color: "#4a5568", fontFamily: isEditMode ? "" : "monospace" }}>
                                                                            <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"RiskClass"} fieldName={"_RiskClass"} fieldTitle={"Risk Class"} LOV={riskClassList} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        </span>
                                                                    </div>

                                                                </div>
                                                            </LayoutComponents.InfoBlock>


                                                            <LayoutComponents.InfoBlock>
                                                                <h3 style={{ margin: "0 0 20px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096", borderBottom: "1px solid #edf2f7", paddingBottom: "10px" }}>
                                                                    Authorized Supply Chain / Operators
                                                                </h3>

                                                                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

                                                                    {/* Entry Node: Distributor */}
                                                                    <div style={{ paddingLeft: "14px", borderLeft: "4px solid #3398dc" }}>
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                            Country Distributor(s)
                                                                        </label>
                                                                        <FieldTypes.ItemDetailsField_MultiSelect key={`dist_${version}`} AppContext={AppContext} fieldTitle={"Country Distributor(s)"} fieldName={"CountryDistributorsIds"} selectedItems={AppContext.currentItem.CountryDistributorsIds} LOV={countryDistributors} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} itemLink={"/your-medboard/country-registrations/operators/?operatorId=[PARAM]"} allowAddOperator={true} operatorRoleId={4} onRefreshOperators={loadCountryDistributors} />
                                                                    </div>

                                                                    {/* Entry Node: Representative */}
                                                                    <div style={{ paddingLeft: "14px", borderLeft: "4px solid #2a6e92" }}>
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                            Country Representative
                                                                        </label>
                                                                        <FieldTypes.ItemDetailsField_MultiSelect key={`rep_${version}`} AppContext={AppContext} fieldTitle={"Country Representative"} fieldName={"CountryRepresentativesIds"} selectedItems={AppContext.currentItem.CountryRepresentativesIds} LOV={countryRepresentatives} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} itemLink={"/your-medboard/country-registrations/operators/?operatorId=[PARAM]"} allowAddOperator={true} operatorRoleId={3} onRefreshOperators={loadCountryRepresentatives} />
                                                                    </div>

                                                                    {/* Entry Node: Importer */}
                                                                    <div style={{ paddingLeft: "14px", borderLeft: "4px solid #203864" }}>
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                            Importer(s)
                                                                        </label>
                                                                        <FieldTypes.ItemDetailsField_MultiSelect key={`imp_${version}`} AppContext={AppContext} fieldTitle={"Importer(s)"} fieldName={"ImportersIds"} selectedItems={AppContext.currentItem.ImportersIds} LOV={importers} LOVIdField={"EstablishmentId"} LOVNameField={"Establishment"} noneIsAll={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} itemLink={"/your-medboard/country-registrations/operators/?operatorId=[PARAM]"} allowAddOperator={true} operatorRoleId={2} onRefreshOperators={loadImporters} />
                                                                    </div>

                                                                </div>

                                                            </LayoutComponents.InfoBlock>



                                                            <LayoutComponents.InfoBlock>
                                                                <h4 style={{ margin: "0 0 16px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096" }}>
                                                                    Custom Fields
                                                                </h4>
                                                                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                                                    {/* CUSTOM USER FIELDS */}
                                                                    {/* CUSTOM USER FIELDS */}
                                                                    {/* CUSTOM USER FIELDS */}
                                                                    <FieldTypes.FieldType_CustomUserFieldsView globalContext={AppContext} isEditing={isEditMode} />
                                                                </div>
                                                            </LayoutComponents.InfoBlock>


                                                        </div>



                                                        {/* RIGHT */}

                                                        <div style={{ flex: 1, minWidth: "280px", display: "flex", flexDirection: "column", gap: "24px" }}>

                                                            <LayoutComponents.InfoBlock>
                                                                <h4 style={{ margin: "0 0 16px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096" }}>
                                                                    Registration Status
                                                                </h4>
                                                                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                                                    <div>
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "2px" }}>
                                                                            Lifecycle Status
                                                                        </label>
                                                                        <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"Status"} fieldName={"_Status"} fieldTitle={"Registration Status"} LOV={registrationStatusList} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={false} renderWith={RegistrationsStatusRender} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                    </div>
                                                                    <div>
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "4px" }}>
                                                                            Expiry Date
                                                                        </label>
                                                                        <FieldTypes.ItemDetailsField_DateUTC AppContext={AppContext} field={"ExpiryDate"} fieldTitle={"Expiry Date"} mandatory={false} forceIsEditing={isEditMode} warning={true} displayFieldOnly={displayFieldOnly} />
                                                                    </div>

                                                                    <div>
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "2px" }}>
                                                                            Selling
                                                                        </label>
                                                                        <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"Selling"} fieldName={"_Selling"} fieldTitle={"Selling"} LOV={yesNoList} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={false} renderWith={YesNoRender} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                    </div>
                                                                    <div>
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "4px" }}>
                                                                            IFU Reference
                                                                        </label>
                                                                        <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"IFUReference"} fieldTitle={"IFU Reference"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                    </div>
                                                                    <div>
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "4px" }}>
                                                                            Registration issued by (Organization)
                                                                        </label>
                                                                        <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"IssuedBy"} fieldTitle={"Registration issued by (Organization)"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                    </div>
                                                                   
                                                                </div>

                                                            </LayoutComponents.InfoBlock>




                                                            <LayoutComponents.InfoBlock>
                                                                <h4 style={{ margin: "0 0 16px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096" }}>
                                                                    Assignments & Alerts
                                                                </h4>
                                                                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                                                                    <div>
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "2px" }}>
                                                                            Assigned To
                                                                        </label>

                                                                        {isEditMode ? 
                                                                            <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"AssignedTo"} fieldName={"_AssignedTo"} fieldTitle={"Assigned To"} LOV={AppContext.users} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                            :
                                                                            <>
                                                                             {AppContext.currentItem?.AssignedTo ?
                                                                                <FieldTypes.FieldType_FullUser
                                                                                    users={AppContext.users}
                                                                                    value={AppContext.currentItem.AssignedTo}
                                                                                /> : "---"}
                                                                            </>
                                                                        }

                                                                    </div>

                                                                    <div>
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "2px" }}>
                                                                            Alert Time (Months before expiration)
                                                                        </label>
                                                                        


                                                                        
                                                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                                                                            {isEditMode ?

                                                                                <div>
                                                                                    <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Months"} fieldTitle={"Months"} mandatory={false} isNumeric={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                                </div>
                                                                                :
                                                                                <>
                                                                                {AppContext.currentItem?.Months ? (
                                                                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                                                        <span className="fas fa-bell"></span>

                                                                                        {/* 2. Display the Months */}
                                                                                        <span>{AppContext.currentItem.Months} Month(s)</span>

                                                                                        {/* 3. Display Calculated Notification Date */}
                                                                                            {AppContext.currentItem.ExpiryDate && (
                                                                                                <span style={{ fontSize: "12px", color: "#718096" }}>
                                                                                                    (Alert Date: {
                                                                                                        (() => {
                                                                                                            const expiry = new Date(AppContext.currentItem.ExpiryDate);

                                                                                                            // Subtract months in UTC
                                                                                                            expiry.setUTCMonth(expiry.getUTCMonth() - AppContext.currentItem.Months);

                                                                                                            const monthNames = [
                                                                                                                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                                                                                                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                                                                                                            ];

                                                                                                            const day = String(expiry.getUTCDate()).padStart(2, "0");
                                                                                                            const month = monthNames[expiry.getUTCMonth()];
                                                                                                            const year = expiry.getUTCFullYear();

                                                                                                            return `${day} ${month}, ${year}`;
                                                                                                        })()
                                                                                                    })
                                                                                                </span>
                                                                                            )}
                                                                                    </div>
                                                                                ) : (
                                                                                    "---"
                                                                                )}
                                                                                </>
                                                                            }

                                                                        </div>

                                                                        

                                                                    </div>

                                                                    <div>
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "2px" }}>
                                                                            Renewal Priority
                                                                        </label>
                                                                        <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"Priority"} fieldName={"_Priority"} fieldTitle={"Renewal Priority"} LOV={renewalPriorityList} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={false} renderWith={PriorityRender} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                    </div>
                                                                </div>
                                                            </LayoutComponents.InfoBlock>





                                                            <LayoutComponents.InfoBlock>
                                                                <h4 style={{ margin: "0 0 16px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096" }}>
                                                                    Notes
                                                                </h4>
                                                                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                                                    
                                                                    <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Notes"} fieldTitle={"Notes"} isTextarea={true} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />

                                                                </div>
                                                            </LayoutComponents.InfoBlock>

                                                        </div>


                                                    </>
                                                    : null}




                                                {/* CONFIGURATIONS */}

                                                {visibleDetailsTab == "configurations" && <>
                                                    <div style={{ height: "100%", overflow: "auto", width: "100%", flex: "1 1 100%" }}>
                                                        <ConfigurableDevicesRegistrationsList AppContext={AppContext} />

                                                    </div>
                                                </>}


                                            </div>


                                    </>
                                )}

                            </div>


                        </div>





                    </div>
                </div>
            
            : null}



            




            {showItemContextMenu && (
                <div
                    ref={contextMenu}
                    style={{
                        position: "fixed",
                        top: `50px`,
                        right: `70px`,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "4px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        borderRadius: "15px",

                    }}
                >

                    {/* DELETE */}
                    {AppContext.userRole === "Admin" ? (
                        !AppContext.isShowingDeleteConfirmation ? (
                            <div className="context-menu-option" onClick={() => AppContext.setIsShowingDeleteConfirmation(true)}>
                                <i className="far fa-trash-alt"></i> Delete this item
                            </div>
                        ) : (
                            AppContext.isDeletingItem ? (
                                <LoadingSpinnerImage />
                            ) : (
                                <div className="context-menu-option context-delete-option" onClick={AppContext.deleteCurrentItem}>
                                    <i className="far fa-trash-alt"></i> Confirm delete?
                                </div>
                            )
                        )
                    ) : (
                        <div className="context-menu-option disabled">
                            <i className="far fa-trash-alt"></i> Delete (No Permission)
                        </div>
                    )}


                </div>
            )}






            
        {/* Unsaved UDI Changes Warning Popup */}
        {/* Unsaved UDI Changes Warning Popup */}

        {AppContext.isShowingProductUnsavedChangesWarning ?

            <div
                style={{
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.4)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000
                }}
            >
                <div
                    style={{
                        width: "360px",
                        backgroundColor: "#fff",
                        borderRadius: "12px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px"
                    }}
                >
                    {/* Title */}
                    <div style={{ fontSize: "1rem", fontWeight: 600 }}>
                        Unsaved Changes
                    </div>

                    {/* Message */}
                    <div style={{ fontSize: "0.9rem", color: "#555", lineHeight: "1.4" }}>
                        There are unsaved changes in the Product Details screen.
                        <br />
                        Please save or cancel your changes before leaving.
                    </div>

                    {/* Actions */}
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                        <button
                            onClick={() => AppContext.setIsShowingProductUnsavedChangesWarning(false)}
                            style={{
                                padding: "8px 16px",
                                backgroundColor: "#1976d2",
                                color: "#fff",
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontSize: "0.85rem",
                                fontWeight: 500,
                                transition: "background-color 0.2s ease"
                            }}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#155fa0"}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#1976d2"}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>

            : null}









        </>
    );
};





const ErrorBullet = ({ error }) => {

    return <>
        {error ? 
            <div style={{
                color: "rgb(255, 84, 0)",
                display: "inline-flex",
                alignItems: "center",
                padding: "6px 14px",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
                border: "1px solid rgb(222, 226, 230)",
                whiteSpace: "nowrap",
                outline: "none",
                borderRadius: "15px",
                backgroundColor: "#fff2f2",
            }}>
                { error }
            </div>
        : null }
    </>

}




const YesNoRender = ({ object }) => {

    const isTrue =
        object === true ||
        object === "true" ||
        object === 1 ||
        object === "1";

    return isTrue ? (
        <span className="u-label g-bg-green g-rounded-3 g-mr-10">
            Yes
        </span>
    ) : (
        <span className="u-label g-bg-lightred g-rounded-3 g-mr-10">
            No
        </span>
    );
};



const PriorityRender = ({ object }) => {

    switch (parseInt(object)) {

        case 1:
            return (
                <span className="u-label g-bg-green g-rounded-3 g-mr-10">
                    Low
                </span>
            );

        case 2:
            return (
                <span className="u-label g-bg-yellow g-rounded-3 g-mr-10">
                    Medium
                </span>
            );

        case 3:
            return (
                <span className="u-label g-bg-lightred g-rounded-3 g-mr-10">
                    High
                </span>
            );

        case 0:
        default:
            return (
                <span className="u-label g-bg-gray-dark-v5 g-rounded-3 g-mr-10">
                    None
                </span>
            );
    }
};






const RegistrationsStatusRender = ({ object }) => {
    return <FieldTypes.FieldType_RegistrationsStatus value={object} />
}









const ItemDetailsField_CertificatesDropdown = ({
    AppContext,
    fieldTitle,
    fieldId,
    fieldName,
    LOV = [],
    mandatory = false,
    defaultEmptyId = "",
    defaultEmptyText = "",
    link = null,
    forceIsEditing = null,
    enableSearch = true,
    displayFieldOnly = false
}) => {

    const [errorVar, setErrorVar] = useState(false);
    const [isEditingField, setIsEditingField] = useState(
        forceIsEditing != null ? forceIsEditing : false
    );

    const [finalLink, setFinalLink] = useState(null);

    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    // ================= NORMALIZED LOV =================
    const normalizedLOV = mandatory
        ? LOV
        : [
            {
                Disabled: false,
                Group: { Disabled: false, Name: "" },
                Selected: false,
                Text: defaultEmptyText,
                Value: defaultEmptyId
            },
            ...LOV
        ];

    // ================= FILTERED =================
    const filteredLOV = enableSearch
        ? normalizedLOV.filter(item =>
            (item?.Text || "")
                .toLowerCase()
                .includes(search.toLowerCase())
        )
        : normalizedLOV;

    // ================= GROUPED + SORTED =================
    const groupedLOV = filteredLOV.reduce((acc, item) => {

        const groupName = item?.Group?.Name || "Other";

        if (!acc[groupName])
            acc[groupName] = [];

        acc[groupName].push(item);

        return acc;

    }, {});

    const sortedGroupedLOV = Object.fromEntries(
        Object.entries(groupedLOV)
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([groupName, items]) => [
                groupName,
                items.sort((a, b) =>
                    (a.Text || "").localeCompare(b.Text || "")
                )
            ])
    );

    // ================= EFFECTS =================
    useEffect(() => {
        if (
            link &&
            AppContext.currentItem[fieldId] &&
            AppContext.currentItem[fieldId] != defaultEmptyId
        ) {
            changeFinalLink(AppContext.currentItem[fieldId]);
        }
    }, []);

    useEffect(() => {
        validate();
    }, [AppContext.currentItem]);

    useEffect(() => {
        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);
    }, [forceIsEditing]);

    // ================= HELPERS =================
    const validate = () => {
        if (
            mandatory &&
            (
                AppContext.currentItem[fieldId] == null ||
                AppContext.currentItem[fieldId] == defaultEmptyId
            )
        )
            setErrorVar(true);
        else
            setErrorVar(false);
    };

    const changeFinalLink = (val) => {
        let tmp = link;

        if (val == defaultEmptyId)
            setFinalLink(null);
        else {
            tmp = tmp.replaceAll("[PARAM]", val);
            setFinalLink(tmp);
        }
    };

    const changeIsEditingField = (state) => {
        if (forceIsEditing != null) return;
        setIsEditingField(state);
    };

    const handleChange = (item) => {

        AppContext.setCurrentItem({
            ...AppContext.currentItem,
            [fieldId]: item.Value,
            [fieldName]: item.Text
        });

        if (link)
            changeFinalLink(item.Value);

        setSearch(item.Text);
        setIsOpen(false);
        changeIsEditingField(false);
    };

    const selectedItem = normalizedLOV.find(
        item => item.Value == AppContext.currentItem[fieldId]
    );

    const clearValue = () => {

        AppContext.setCurrentItem({
            ...AppContext.currentItem,
            [fieldId]: defaultEmptyId,
            [fieldName]: defaultEmptyText
        });

        if (link)
            changeFinalLink(defaultEmptyId);

        setSearch("");
        setIsOpen(false);
        changeIsEditingField(false);
    };



    const fieldContent = (

        <div className="view-task-field-value">

            {/* ================= VIEW MODE ================= */}
            {isEditingField === false ? (

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start"
                    }}
                >

                    <span
                        className={`editable-field-span ${errorVar ? "form-field-error" : ""}`}
                        onClick={() => {
                            changeIsEditingField(true);
                            setSearch("");
                        }}
                    >

                        {AppContext.currentItem[fieldId] === defaultEmptyId ? (

                            <FieldTypes.ItemDetailsField_EmptyValue />

                        ) : (

                            (() => {

                                if (!selectedItem)
                                    return <FieldTypes.ItemDetailsField_EmptyValue />;

                                return finalLink ? (

                                    <a
                                        href={finalLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {selectedItem.Text}
                                    </a>

                                ) : (

                                    selectedItem.Text

                                );

                            })()

                        )}

                    </span>

                    {errorVar && (

                        <span className="form-field-error-message">
                            The field {fieldTitle} is necessary
                        </span>

                    )}

                </div>

            ) : (

                /* ================= EDIT MODE ================= */
                <div
                    style={{
                        position: "relative",
                        width: "100%"
                    }}
                >

                    <input
                        type="text"
                        value={
                            isOpen
                                ? search
                                : (selectedItem?.Text || "")
                        }
                        placeholder={`Select ${fieldTitle}`}
                        onFocus={() => {
                            setIsOpen(true);
                            setSearch("");
                        }}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setIsOpen(true);
                        }}
                        onBlur={() => {
                            setTimeout(() => setIsOpen(false), 150);
                            changeIsEditingField(false);
                        }}
                        style={{
                            width: "100%",
                            padding: "6px",
                            paddingRight: "32px",
                            borderRadius: "4px",
                            border: "1px solid #ccc"
                        }}
                    />

                    {(AppContext.currentItem[fieldId] || search) && (

                        <button
                            type="button"
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={clearValue}
                            style={{
                                position: "absolute",
                                right: "8px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                fontSize: "16px",
                                color: "#888",
                                padding: 0,
                                lineHeight: 1
                            }}
                        >
                            ×
                        </button>

                    )}

                    {isOpen && (

                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                maxHeight: "260px",
                                overflowY: "auto",
                                background: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                zIndex: 1000
                            }}
                        >

                            {Object.keys(sortedGroupedLOV).length > 0 ? (

                                Object.entries(sortedGroupedLOV).map(
                                    ([groupName, items]) => (

                                        <div key={groupName}>

                                            <div
                                                style={{
                                                    padding: "8px 10px",
                                                    fontWeight: "bold",
                                                    background: "#f5f5f5",
                                                    borderBottom: "1px solid #eee",
                                                    fontSize: "12px",
                                                    color: "#666"
                                                }}
                                            >
                                                {groupName}
                                            </div>

                                            {items.map(item => (

                                                <div
                                                    key={item.Value}
                                                    onMouseDown={(e) =>
                                                        e.preventDefault()
                                                    }
                                                    onClick={() =>
                                                        handleChange(item)
                                                    }
                                                    style={{
                                                        padding: "8px 10px",
                                                        cursor: item.Disabled
                                                            ? "not-allowed"
                                                            : "pointer",
                                                        opacity: item.Disabled
                                                            ? 0.5
                                                            : 1,
                                                        background:
                                                            AppContext.currentItem[fieldId] == item.Value
                                                                ? "#f0f7ff"
                                                                : "#fff"
                                                    }}
                                                >

                                                    {item.Text}

                                                </div>

                                            ))}

                                        </div>

                                    )
                                )

                            ) : (

                                <div
                                    style={{
                                        padding: "8px 10px",
                                        color: "#888"
                                    }}
                                >
                                    No results
                                </div>

                            )}

                        </div>

                    )}

                </div>

            )}

        </div>

    );

    return displayFieldOnly ? (
        fieldContent
    ) : (
        <div className="view-task-field">

            <div className="view-task-field-line">

                <div className="view-task-field-title">
                    {fieldTitle}
                </div>

                {fieldContent}

            </div>

        </div>
    );



};


const ConfigurableDevicesRegistrationsList = ({ AppContext }) => {
    const [configurations, setConfigurations] = useState([]);
    const [originalConfigurations, setOriginalConfigurations] = useState([]);

    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState(null);
    const [saveSuccess, setSaveSuccess] = useState(false);

    const isAdmin = AppContext.userRole === "Admin";
    let registrationsConfigurationsUrl = "/Umbraco/API/RIMSRegistrations/ConfigurableDevices?id="

    useEffect(() => {
        setIsLoading(true);

        let url = registrationsConfigurationsUrl + AppContext.currentItem.Id;

        fetch(url, { method: "GET" })
            .then((response) => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then((result) => {
                if (result) {
                    setConfigurations(result);
                    setOriginalConfigurations(result);
                }
            })
            .catch((error) => {
                console.log("error: " + error);
                setError(error.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [AppContext]);

    const handleChange = (index, field, value) => {
        const updated = [...configurations];
        updated[index] = {
            ...updated[index],
            [field]: field === "Available" ? parseInt(value, 10) : value
        };
        setConfigurations(updated);
    };

    const cancel = () => {
        setConfigurations(originalConfigurations);
        setIsEditing(false);
        setError(null);
    };

    const save = () => {
        let data = configurations;

        setError(null);
        setIsSaving(true);
        setSaveSuccess(false);

        let url = registrationsConfigurationsUrl + AppContext.currentItem.Id;

        fetch(url, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        })
            .then((response) => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then((result) => {
                if (result) {
                    setConfigurations(result.ConfigurableDeviceRegistrations || configurations);
                    setOriginalConfigurations(result.ConfigurableDeviceRegistrations || configurations);
                    setSaveSuccess(true);
                    setIsEditing(false);
                }
            })
            .catch((error) => {
                console.log("error: " + error);
                setError(error.message);
            })
            .finally(() => {
                setIsSaving(false);
            });
    };

    return (
        <div className="tab-pane fade show active" id="configurable_devices" role="tabpanel">
            <div style={{ height: "100%", overflow: "auto", width: "100%" }} className="col-lg-12">
                <div style={{
                    background: "rgb(255, 255, 255)",
                    border: "1px solid rgb(226, 232, 240)",
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "rgba(0, 0, 0, 0.02) 0px 4px 6px -1px"
                }}>
                    {isLoading ? (
                        <LoadingSpinnerImage />
                    ) : !configurations || configurations.length === 0 ? (
                        <span>The product associated with this registration doesn't have any configurations.</span>
                    ) : (
                        <div>
                            <h3>Configurations of {AppContext.currentItem.ProductSKUCode} for this registration</h3>

                            {/* EDIT BUTTON (ONLY WHEN NOT EDITING) */}
                            {isAdmin && !isEditing && (
                                <div style={{ textAlign: "right", marginBottom: "15px" }}>
                                    <div className="view-task-field" style={{ textAlign: "right" }}>
                                        <span
                                            onClick={() => { setSaveSuccess(false); setIsEditing(true); }}
                                            style={{ borderRadius: "20px", cursor: "pointer" }}
                                            className="edit-rims-edit-button"
                                        >
                                            <i className="fas fa-edit g-pr-8"></i>Edit
                                        </span>
                                    </div>
                                </div>
                            )}

                            <table className="table g-mt-20 table-bordered" id="selectedDevicesTable">
                                <thead>
                                    <tr>
                                        <th style={{ width: "20%" }}>Reference</th>
                                        <th style={{ width: "30%" }}>Description</th>
                                        <th style={{ width: "20%" }}>Selling</th>
                                        <th style={{ width: "30%" }}>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {configurations.map((config, index) => (
                                        <tr key={config.Id || index} data-id={config.ConfigurableDeviceId}>
                                            <td>{config.Reference}</td>
                                            <td>{config.Description}</td>
                                            <td>
                                                {isEditing ? (
                                                    <select
                                                        className="form-control"
                                                        value={config.Available}
                                                        onChange={(e) => handleChange(index, "Available", e.target.value)}
                                                    >
                                                        <option value={1}>Yes</option>
                                                        <option value={0}>No</option>
                                                    </select>
                                                ) : (
                                                    <span>{config.Available === 1 ? "Yes" : "No"}</span>
                                                )}
                                            </td>
                                            <td>
                                                {isEditing ? (
                                                    <input
                                                        type="text"
                                                        className="form-control edit-input"
                                                        value={config.SaleDescription || ""}
                                                        onChange={(e) => handleChange(index, "SaleDescription", e.target.value)}
                                                    />
                                                ) : (
                                                    <span>{config.SaleDescription}</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {saveSuccess && (
                                <span style={{ color: "green", display: "block", marginBottom: "10px" }}>
                                    Configurations saved!
                                </span>
                            )}

                            {error && (
                                <span style={{ color: "red", display: "block", marginBottom: "10px" }}>
                                    Error: {error}
                                </span>
                            )}

                            {/* SAVE / CANCEL BUTTONS */}
                            {isAdmin && isEditing && (
                                <div className="form-group" style={{ textAlign: "right" }}>
                                    {isSaving ? (
                                        <LoadingSpinnerImage small={true} />
                                    ) : (
                                        <>
                                            <button
                                                onClick={cancel}
                                                className="action-button save-button g-mr-10"
                                                style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    padding: "6px 14px",
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out",
                                                    whiteSpace: "nowrap",
                                                    outline: "none",
                                                    color: "#5f6368",
                                                    border: "1px solid #dee2e6",
                                                    backgroundColor: "#ffffff",
                                                    marginRight: "10px"
                                                }}
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                onClick={save}
                                                className="action-button save-button"
                                                style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    padding: "6px 14px",
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out",
                                                    whiteSpace: "nowrap",
                                                    outline: "none",
                                                    color: "#ffffff",
                                                    border: "1px solid #1a73e8",
                                                    backgroundColor: "#1a73e8",
                                                }}
                                            >
                                                Save Configurations
                                            </button>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};


export default ItemDetailsPane;